<template>
    <div class="right-content-sl">
        <div class="small-title-sl">{{ $t('sl.calendar.title') }}</div>
        <div class="div-calendar">
            <div class="today-date-sl" v-bind:style="{ display: currentDayDisplay}">
                <b class="today-weekday">{{$t('sl.calendar.weekdays.abbreviation.'+currentDayOfWeek)}}</b><br/>
                <b class="today-date">{{currentDate}}</b>
            </div>
            <vc-calendar :attributes="attributesCalendar" @update:from-page="changeMonth" title-position="left" :locale="currentLang" :firstDayOfWeek="calendarFirstDayOfWeek" class="custom-v-calendar-style" />
        </div>
        
        
    </div>
</template>
<script>
    import Vue from 'vue';
     import { mapActions } from "vuex";
    import VCalendar from 'v-calendar';
    import calendarConfig from '../../datas/calendarConfig';

    Vue.use(VCalendar, {
        componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
        locales: {
            'fr': {
                firstDayOfWeek: 2,
                masks: {
                    L: 'YYYY-MM-DD',
                    weekdays: "WWW"
                }
            },
            'en': {
                firstDayOfWeek: 2,
                masks: {
                    L: 'YYYY-MM-DD',
                    weekdays: "WWW"
                }
            }
        }
    });

    export default {
        name: 'calendar-sl',
        props: {
            meetupsCalendar:[]
        },
         data() {
            var today = new Date();
            var dayOfWeek = today.getDay();
            var dateMonth=today.getDate();
            this.loadServiceLines();
            return {
                calendarConfig,
                currentLang:Vue.i18n.locale(),
                calendarFirstDayOfWeek:2,
                today:today,
                currentDayOfWeek:dayOfWeek,
                currentDate:dateMonth,
                calendarRequest: {
                    month: '',
                    year: '',
                    lan:''
                },
                serviceLinesCalendar:[],
                currentDayDisplay:'block'

            };
        },
        computed: {
            attributesCalendar() {
                return [
                    {
                        key: 'today',
                        highlight: this.$data.calendarConfig.backgroundDefaultColor,
                        dates: new Date(),
                    },   
                    ...this.$data.serviceLinesCalendar.map(t => ({
                        key: `todo.${t.id}`,
                        dot: {
                            color:this.getDotColor(t.date,this.$data.today)
                        },
                        dates: this.convertToDate(t.date),
                        customData: t,
                        popover: {
                            label: t.title
                        },
                    }))
                ]
            }
        },
        methods:{
            ...mapActions(["GetCalendarServiceLines"]),
            async loadServiceLines() {
                var today = new Date();
                this.calendarRequest={
                    month: today.getMonth()+1,
                    year:today.getFullYear() ,
                    lang:Vue.i18n.locale()
                }
                await this.GetCalendarServiceLines(this.calendarRequest);
                this.serviceLinesCalendar = this.$store.getters.AllServiceLines; 
            },
            getDotColor(dateMeetup,today){
                if(this.convertToDate(dateMeetup)<today){
                    return this.$data.calendarConfig.dotPastColor;
                }
                else{
                    return this.$data.calendarConfig.dotDefaultColor;
                } 
            },
            convertToDate(stringDate){
                const sYear=stringDate.toString().substring(0, 4);
                const sMonth=stringDate.toString().substring(4,6);
                const sDay=stringDate.toString().substring(6);
                return new Date(sYear, sMonth-1, sDay);
            },
            async changeMonth(selectedMonth) { 
                let calendarRequest={
                    month:selectedMonth.month,
                    year:selectedMonth.year ,
                    lang:Vue.i18n.locale()
                }
                await this.GetCalendarServiceLines(calendarRequest);
                this.serviceLinesCalendar = this.$store.getters.AllServiceLines;
                if(this.$data.today.getMonth()===(selectedMonth.month-1) && this.$data.today.getFullYear()===selectedMonth.year){
                    this.currentDayDisplay='block';
                }
                else{
                    this.currentDayDisplay='none';
                }
            }
        } 
    }
</script>
